import React, { useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { CTitle } from '../../components/Widget';
import { useUpdateComponentState } from '../../../hooks';
import WhyStudentTargetReasons from '../../components/WhyStudentTargetReasons';
import IntegratedServiceList from '../../components/IntegratedServiceList';
import robot from '../../../../../../assets/sme/uats/robot.png';

interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();

  const toolTypeItems = useMemo(
    () =>
      (paragraphsSettings?.toolTypes ?? []).map(
        (tool: { name: string; desc: string }) => ({
          title: tool.name,
          desc: tool.desc,
        })
      ),
    [paragraphsSettings?.toolTypes]
  );

  const accessItems = useMemo(
    () =>
      (paragraphsSettings?.accessList ?? []).map(
        (item: { title: string; detail: string }, index: number) => ({
          id: index,
          label: item.title,
          content: <p className="uats-access-detail-text">{item.detail}</p>,
        })
      ),
    [paragraphsSettings?.accessList]
  );

  const handleAccessComplete = useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-uats-section1-1'
    );
  }, [updateComponentState, p_course, p_topic]);

  return (
    <div className="topic-section-1">
      <CTitle title={paragraphsSettings?.title} />
      <p className="uats-section-desc">{paragraphsSettings?.desc}</p>

      <WhyStudentTargetReasons
        title={paragraphsSettings?.toolTypesTitle}
        items={toolTypeItems}
      />

      <IntegratedServiceList
        title={paragraphsSettings?.accessTitle}
        description={paragraphsSettings?.accessDesc}
        image={robot}
        items={accessItems}
        id="student-training-uats-section1-1"
        onComplete={handleAccessComplete}
      />
    </div>
  );
};

export default Section1;
